import { IFilterSignature } from "./types"

import { Button, Container, Divider, Drawer, Empty, Flex, Input, Toogle, ToolTip } from "@ui/index"

import imgEmty from '@img/empty.svg'
import { IconClearClose, IconDateEdit } from "@img/icons"

import css from './ui.module.scss'
import { SelectDate } from "@primitive/calendar"

/** Фильтр - Договора на подпись */
export const SignatureFilter = ({ 
    isOpen, 
    filterSignatureStatuses,
    filterDateNextCallFrom,
    filterDateNextCallBefore,

    handleButtonCancel, handleApplyClearFilter
}: IFilterSignature) => {

    /** Выбор статусов в окне фильтров */
    const handleSelectStatus = (id: number) => {
        const updatedStatuses = filterSignatureStatuses.value.map(status => {
            if (status.id === id) {
                return { ...status, isSelected: !status.isSelected }
            }

            return status // Возвращаем неизмененный элемент для остальных элементов массива
        })

        filterSignatureStatuses.setValue(updatedStatuses)
    }
    /** Убираем все галочки с выбранных статусов в окне фильтров */
    const handleClearSelection = () => {
        const updatedStatuses = filterSignatureStatuses.value.map(status => ({ ...status, isSelected: false }))
        filterSignatureStatuses.setValue(updatedStatuses)
    }

    return <>
        <Drawer isOpen={isOpen} zIndex={1001} isEsc isWrapper isWrapperBlur={false} onCancel={handleButtonCancel} maxWidth='370px' placement='right'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <h4>Фильтр...</h4>

                    <Button id='tooltipBtnClose' variant='icon' size='md' onClick={handleButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body'>
                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="4px">
                            <Divider prefix='Дата отложенного звонка' gap="6px"
                                suffix={(filterDateNextCallFrom.value || filterDateNextCallBefore.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterDateNextCallFrom.reset()
                                            filterDateNextCallBefore.reset() 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateNextCallFrom} 
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateNextCallFrom.value &&
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={filterDateNextCallFrom.reset}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateNextCallFrom.value} onSelect={(date) => {filterDateNextCallFrom.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput'>
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateNextCallBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateNextCallBefore.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={filterDateNextCallBefore.reset}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateNextCallBefore.value} onSelect={(date) => {filterDateNextCallBefore.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput' >
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Показать только выбранные статусы' gap="6px" suffix={
                                filterSignatureStatuses.value.filter((item) => item.isSelected === true).length > 0 && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={handleClearSelection}>
                                            <IconClearClose width='16px' height='16px' />
                                        </Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="4px">
                                {filterSignatureStatuses.value.length === 0
                                    ? <Empty image={imgEmty} title="Данные отсутствуют" size='100px' /> 
                                    : filterSignatureStatuses.value.map((item) => {
                                        return (
                                            <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                                <p>{item.name}:</p>
                                                <Toogle checked={item.isSelected} onChange={() => handleSelectStatus(item.id)} />
                                            </Container>
                                        )
                                    })
                                }
                            </Flex>
                        </Flex>
                    </Flex>

                    <div style={{gap: '5px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <Button variant="primaryDark" onClick={() => handleApplyClearFilter('clear')}>Очистить</Button>
                        <Button onClick={() => handleApplyClearFilter('apply')}>Применить</Button>
                    </div>
                </Flex>
            </Flex>
        </Drawer>
    </>
}